
export const casService = {
    loginSSO: (serviceName) => {
        var serviceURL = window.location.origin + serviceName;
        window.location.href = Configs.casService + "/login?service=" + encodeURIComponent(serviceURL);
    },
    logoutSSO: (serviceName) => {
        var serviceURL = window.location.origin + serviceName;
        var loginSSOURL = encodeURIComponent(serviceURL);
        window.location.href = Configs.casService + "/logout?service=" + loginSSOURL;
    }
}

export const Configs = {
    casService: "https://dangnhap.danang.gov.vn/cas"
};